import Link from '@material-ui/core/Link';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { theme } from 'assets/theme';
import ListItemComponent, { IStateListItem } from 'components/Abstract/ListItem';
import { IEntity } from 'interfaces/entity';
import * as React from 'react';
import { dateFormat } from '../../../../../../formatters/date';

interface IState extends IStateListItem {
  entityInfo: any;
}

interface IProps {
  file: any;
  entities: IEntity[],
}

export default class ListItem extends ListItemComponent<IProps, IState> {
  readonly tableRow = { height: theme.spacing(6) };

  componentDidMount = () => {
    const { entityId, tabId, subTabId } = this.props.file;
    const entity = this.props.entities.find(entity => entity.id === entityId);
    const tab = this.props.entities.find(entity => entity.id === tabId);
    const subTab = this.props.entities.find(entity => entity.id === subTabId);

    return this.setState({
      entityInfo: {
        entity: entity ? entity.name : '',
        tab: tab ? tab.name : '',
        subTab: subTab ? subTab.name : '-',
      }
    });
  };

  render(): JSX.Element {
    const { entityInfo } = this.state;
    const { file } = this.props;

    if (!entityInfo) {
      return null;
    }

    return (
      <TableRow style={this.tableRow}>
        <TableCell>
          {file.uploadDate ? dateFormat(new Date(`${file.uploadDate}Z`), 'dd/MM/yyyy - HH:mm') : '-'}
        </TableCell>
        <TableCell>{entityInfo.entity}</TableCell>
        <TableCell>{entityInfo.tab}</TableCell>
        <TableCell>{entityInfo.subTab}</TableCell>
        <TableCell>
          {file.name}
        </TableCell>
        <TableCell>
          {file.url ?
            <Link target="blank" rel="noopener noreferrer" href={file.url}>
              {file.filename}
            </Link>
            : '-'}
        </TableCell>
        <TableCell>
          {file.firstName} {file.lastName} - {file.email}
        </TableCell>
      </TableRow>
    );
  }
}